import { Card, Center, Flex, Loader, Stack, Text } from '@mantine/core'
import { ReactElement } from 'react'

import { CopyWidgetButton } from './copy-widget-button'

export const ContactsDiscoveryCard = ({
  isFetching,
  companies,
  contacts,
  rateOfChange,
}: {
  isFetching: boolean
  companies: number
  contacts: number
  rateOfChange: string
}) => {
  const { targetRef, copyButton } = CopyWidgetButton({ title: 'CONTACTS DISCOVERY' })
  return (
    <div ref={targetRef} style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
      <Flex
        align='stretch'
        style={{
          flexBasis: '50%',
        }}
      >
        <div
          style={{
            flexBasis: '100%',
          }}
        >
          {isFetching ? (
            <Center h='100%' w='100%'>
              <Loader />
            </Center>
          ) : (
            <ContactsDiscoveryCompaniesCard companies={companies} copyButton={copyButton} />
          )}
        </div>
      </Flex>
      <Flex
        align='stretch'
        style={{
          flexBasis: '50%',
        }}
        ref={targetRef}
      >
        <div
          style={{
            flexBasis: '100%',
          }}
        >
          {isFetching ? (
            <Center h='100%' w='100%'>
              <Loader />
            </Center>
          ) : (
            <ContactsDiscoveryContactsCard contacts={contacts} rateOfChange={rateOfChange} />
          )}
        </div>
      </Flex>
    </div>
  )
}
export const ContactsDiscoveryCompaniesCard = ({
  companies,
  copyButton,
}: {
  companies: number
  copyButton: ReactElement
}) => {
  return (
    <Card
      shadow='sm'
      c='#868e96'
      radius={0}
      style={{
        height: '100%',
        borderTopLeftRadius: '0.5rem',
        borderTopRightRadius: '0.5rem',
        borderLeft: '0.0625rem solid #dee2e6',
        borderRight: '0.0625rem solid #dee2e6',
        borderTop: '0.0625rem solid #dee2e6',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Text fw={600}>CONTACTS DISCOVERY</Text>
        {copyButton}
      </div>
      <Stack
        style={{
          padding: 10,
          paddingRight: 0,
        }}
      >
        <Text>Companies</Text>
        <Text c='black' fz={20} fw={600}>
          {companies}
        </Text>
      </Stack>
    </Card>
  )
}
export const ContactsDiscoveryContactsCard = ({
  contacts,
  rateOfChange,
}: {
  contacts: number
  rateOfChange: string
}) => {
  return (
    <Card
      shadow='sm'
      radius={0}
      c='#868e96'
      style={{
        height: '100%',
        borderBottomLeftRadius: '0.5rem',
        borderBottomRightRadius: '0.5rem',
        borderLeft: '0.0625rem solid #dee2e6',
        borderRight: '0.0625rem solid #dee2e6',
        borderBottom: '0.0625rem solid #dee2e6',
      }}
    >
      <div
        style={{
          border: '0.0625rem solid #dee2e6',
          marginTop: -13,
        }}
      ></div>
      <Stack
        style={{
          padding: 10,
          paddingRight: 0,
        }}
      >
        <Text
          style={{
            paddingTop: 40,
          }}
        >
          Contacts
        </Text>
        <div>
          <Text c='black' fz={20} fw={600}>
            {contacts}
          </Text>
          {rateOfChange && <div style={{ color: '#1ec78c' }}>{rateOfChange} this week</div>}
        </div>
      </Stack>
    </Card>
  )
}
